// Utilitaire pour formater la date au format "jour/mois/année"
export function formatFrenchDate(dateString) {
    const dateObj = new Date(dateString);
    const jour = dateObj.getDate().toString().padStart(2, '0');
    const mois = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const annee = dateObj.getFullYear();
    return `${jour}/${mois}/${annee}`;
}
